export default () => ({
  teamMembers: [],
  teamMembersSummarized: {},
  measureScores: {},
  teamMeasureScores: {},
  campaignId: null,
  loadedData: false
})
